<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <div class="text-xs-center">
      <svg-buttons @mostrar="textoActual = $event" @finished="$store.commit('nextShow', true)" />
      <v-layout justify-center>
        <v-flex xs12 md8>
          <transition name="custom" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster" mode="out-in">
            <p class="texto1 mt-4" :key="textoActual" v-if="textoActual>=0">
              <span v-html="textos[textoActual]"></span>
            </p>
          </transition>
        </v-flex>
      </v-layout>
    </div>

    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 06'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 1/diapositiva-5'
export default {
  components: {
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "Bien, ya vamos comprendiendo más acerca de las reservas y recursos, su importancia y estimación pero, ¿qué sucede si hay una sobreestimación?, ¿cuáles son sus causas? <span class='instruccion'>Haz clic en los iconos.</span>" 
      ],
      textos: [
        "Prácticas pobres de estimación o desconocimiento.",
        "Controles internos inadecuados.",
        "Incentivos mal enfocados (bonos) y competencias por inversionistas.",
        "Sesgo en las apreciaciones y percepción del riesgo.",
        "Falta de profesionalismo, debido a que los funcionarios a cargo de la estimación no asumen su rol con objetividad, ni responsabilidad."
      ],
      textoActual: -1
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  }
}
</script>
<style lang="scss" scoped>
</style>
